"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllFieldNames = exports.isFieldGroup = exports.isSimpleField = void 0;
const jfl_mapper_1 = __importDefault(require("./jfl-mapper"));
const jfl_validator_1 = __importDefault(require("./jfl-validator"));
function isSimpleField(jflDef) {
    return !Array.isArray(jflDef.field);
}
exports.isSimpleField = isSimpleField;
function isFieldGroup(jflDef) {
    return Array.isArray(jflDef.field);
}
exports.isFieldGroup = isFieldGroup;
function createJFL(jfd, jfl) {
    return new JFLImpl(jfd, jfl);
}
exports.default = createJFL;
class JFLImpl {
    constructor(jfd, jflDef) {
        this.groups = jfl_mapper_1.default(jfd, jflDef).groups;
        const errors = jfl_validator_1.default(jfd, this);
        if (errors.length > 0) {
            throw new Error('Invalid JFL:\n' + formatJFLErrors(errors));
        }
    }
}
function formatJFLErrors(errors) {
    return errors
        .map((err) => `${err.location} -- ${err.message}`) //
        .join('\n');
}
function getAllFieldNames(from) {
    // Converge data sources
    let groups;
    if (from.hasOwnProperty('groups')) {
        groups = [...from.groups];
    }
    else {
        groups = [from];
    }
    // Reduce list of groups
    return groups.reduce((result, group) => {
        // Reduce fields in the group
        return group.fields.reduce((fieldsInGroup, jflDef, fieldIdx) => {
            let fields;
            if (isFieldGroup(jflDef)) {
                fields = jflDef.field;
            }
            else {
                fields = [jflDef.field];
            }
            // Map each field to a FieldDescriptor
            const fieldDescriptors = fields.map((field) => {
                return {
                    name: field,
                    // This returns the index within the group instead of the entire JFL
                    index: fieldIdx
                };
            });
            // Accumulate field descriptors
            return [...fieldsInGroup, ...fieldDescriptors];
        }, result);
    }, []);
}
exports.getAllFieldNames = getAllFieldNames;
//# sourceMappingURL=jfl.js.map